import pagingTableComponent from './paging-table.component';

const pagingTableModule = angular.module('pagingTable', [
])
  .component('pagingTable', pagingTableComponent)
  .name;

export default pagingTableModule;
